import React, { ReactNode, useMemo } from 'react';
import { Box } from '../../legacy/Box';

type BannerVariant = 'default' | 'success' | 'warning' | 'danger';

interface BannerRootProps {
  children: ReactNode;
  variant: BannerVariant;
}

export const BannerRoot = ({ children, variant, ...rest }: BannerRootProps) => {
  const contextValue = useMemo(() => ({ variant }), [variant]);

  return (
    <BannerContext.Provider value={contextValue}>
      <Box width={1} data-component="BannerRoot" role="alert" {...rest}>
        {children}
      </Box>
    </BannerContext.Provider>
  );
};

export const BannerContext = React.createContext<{ variant: BannerVariant }>({
  variant: 'default',
});
